// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","getInTouchCTA":"Gbe8f19","heading":"G0285a8 Gfbbf38","text":"G5606e0"};